import type { TooltipProps } from '@mui/material';
import { Tooltip } from '@mui/material';
import React from 'react';

type VyHintProps = Omit<TooltipProps, 'children'>;

export const VyHint: React.FC<VyHintProps> = (props) => {
  return (
    <Tooltip
      placement="top"
      arrow
      {...props}
    >
      <span className="flex bg-[#9EC3E4] cursor-pointer rounded-full w-4 h-4 text-white select-none text-xs justify-center items-center">
        ?
      </span>
    </Tooltip>
  );
};